import formatNumber from "format-number";

export default formatNumber({ integerSeparator: " ", decimal: "," });
